// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Help: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M12,23.95c-3.06,0-6.12-1.16-8.45-3.49c-4.66-4.66-4.66-12.24,0-16.9C5.8,1.29,8.8,0.05,12,0.05c3.19,0,6.19,1.24,8.45,3.5
	c2.26,2.26,3.5,5.26,3.5,8.45s-1.24,6.19-3.5,8.45C18.12,22.79,15.06,23.95,12,23.95z M12,1.42c-2.83,0-5.49,1.1-7.49,3.1
	c-4.13,4.13-4.13,10.84,0,14.97c4.13,4.13,10.85,4.13,14.97,0c2-2,3.1-4.66,3.1-7.49s-1.1-5.49-3.1-7.49
	C17.48,2.52,14.82,1.42,12,1.42z"/>
<rect x="10.88" y="16.41" width="1.37" height="1.45"/>
<path d="M12.25,14.95h-1.37v-0.36c0-2.57,1.76-3.48,1.83-3.52c0.47-0.24,1.8-1.1,1.8-1.93c0-1.15-0.85-1.86-2.23-1.86
	c-2.23,0-2.23,0.77-2.23,1.14H8.7c0-1.14,0.62-2.5,3.59-2.5c2.11,0,3.59,1.33,3.59,3.23c0,1.82-2.3,3.02-2.56,3.16
	c-0.04,0.02-1.08,0.6-1.08,2.3V14.95z"/>
</svg>;
};

export default React.memo(Help);
